<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="可用量表"
      :page="page"
      :show-query="true"
      :queryParamsAppend="params"
      :get-data-func="api.productAvailableRpt"
      v-if="trendShow"
      @selectClick="selectClick"
      urlHash="business/stock/usablescale"
    >  
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template> 
      <template slot="query">
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

   
  </div>
</template>
<script>

  
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require('@/api/stock/stReport').default,
      trendShow: true,
      tableData: [],
      ProductName: "",
      params: {
        ItemValue: null 
      },      
    };
  },
   mounted(){
     ;
  },
  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.productAvailableRptExport(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    selectClick(data, tableName){
      if(tableName === 'BaseQuantity'){
        this.$router.push({ name: "currentstock", params: data });
      }else if(tableName === 'PreEntryBaseQuantity'){
        this.$router.push({ name: "warehousingdetail", params: data });
      }else if(tableName === 'PreReleaseBaseQuantity'){
        this.$router.push({ name: "outbounddetail", params: data });
      }
      console.log('data', data, tableName)
    }
   
  }
};
</script>
